var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgType2Slider2Right(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.378 15.214L22.2 22.475M8.55301 12.473L14.559 8.14905L8.55301 12.473ZM9.80001 22.475L7.62201 15.214L9.80001 22.475ZM19.911 24.178H12.089H19.911ZM17.441 8.14905L23.467 12.487L17.441 8.14905Z",
    stroke: "#D8D8D8",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.222 10.666C18.0627 10.666 19.555 9.17377 19.555 7.333C19.555 5.49223 18.0627 4 16.222 4C14.3812 4 12.889 5.49223 12.889 7.333C12.889 9.17377 14.3812 10.666 16.222 10.666Z",
    fill: "#D8D8D8",
    stroke: "#D8D8D8",
    strokeWidth: 0.711,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.111 17.066C26.9518 17.066 28.444 15.5738 28.444 13.733C28.444 11.8923 26.9518 10.4 25.111 10.4C23.2703 10.4 21.778 11.8923 21.778 13.733C21.778 15.5738 23.2703 17.066 25.111 17.066Z",
    fill: "#D8D8D8",
    stroke: "#D8D8D8",
    strokeWidth: 0.711,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.911 27.733C23.7518 27.733 25.244 26.2408 25.244 24.4C25.244 22.5593 23.7518 21.067 21.911 21.067C20.0702 21.067 18.578 22.5593 18.578 24.4C18.578 26.2408 20.0702 27.733 21.911 27.733Z",
    fill: "#D8D8D8",
    stroke: "#D8D8D8",
    strokeWidth: 0.711,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.533 27.733C12.3738 27.733 13.866 26.2408 13.866 24.4C13.866 22.5593 12.3738 21.067 10.533 21.067C8.69225 21.067 7.20001 22.5593 7.20001 24.4C7.20001 26.2408 8.69225 27.733 10.533 27.733Z",
    fill: "#D8D8D8",
    stroke: "#D8D8D8",
    strokeWidth: 0.711,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.333 17.066C9.17377 17.066 10.666 15.5738 10.666 13.733C10.666 11.8923 9.17377 10.4 7.333 10.4C5.49223 10.4 4 11.8923 4 13.733C4 15.5738 5.49223 17.066 7.333 17.066Z",
    fill: "#D8D8D8",
    stroke: "#D8D8D8",
    strokeWidth: 0.711,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgType2Slider2Right);
export default __webpack_public_path__ + "static/media/Type 2_slider 2_right.0ce5b59e8fa846266bb679f48f9b7fd8.svg";
export { ForwardRef as ReactComponent };